<div class="row">
    <div class="col-md-4 pad-80 pad-right-30">
        <label class="fw-bold text-dark mb-3">ADD/UPDATE </label> : MASTER DATA
        <form [formGroup]="masterDataForm" (ngSubmit)="onSubmit()">
            <div class="customBg">
                <div class="row mb-2">
                    <div class="col-md-2 align-self-center">
                        <label class="required">Name</label>
                    </div>
                    <div class="col-md-10">
                        <select class="form-select" formControlName="name" (change)="onNameChange()">
                            <option *ngFor="let itemName of itemNames" [value]="itemName">{{ itemName }}</option>
                        </select>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-2 align-self-center pe-0">
                        <label class="required">Value</label>
                    </div>
                    <div class="col-md-10">
                        <input type="text" class="form-control" maxlength="200" id="value" formControlName="value">
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-12 text-end">
                    <button type="button" class="btn progressBtn" role="button" (click)="clearForm()">
                        <img src="assets/images/close_mark.svg" class="datePickerIcon" alt="">
                        CLEAR
                    </button>
                    &nbsp;
                    <button class="btn progressBtn float-end" role="button">
                        <img src="assets/images/plus_icon.svg" class="datePickerIcon" alt="">
                        {{buttonText}}
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="col-md-8 pad-80">
        <div class="row">
            <div class="col-md-6">
                <label class="fw-bold text-dark mb-0">EDIT
                    EXISTING</label> : {{selectedName}}
            </div>
            <div class="col-md-6 position-relative">
                <form [formGroup]="searchForm">
                    <input type="text" class="form-control" formControlName="searchControl"
                        placeholder="SEARCH BY VALUE">
                </form>
            </div>
        </div>
        <div class="table-responsive tableFixHead mt-3">
            <table class="table datatable border-x-0 mb-0">
                <thead>
                    <tr class="subheaderrr">
                        <th scope="col" class="text-start py-2" width="50%">Value</th>
                        <th scope="col" class="text-start py-2">
                            Is Active</th>
                        <th scope="col" class="text-start py-2 border-end-0" width="8%">
                            ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of filteredMasterDataValues">
                        <td class="vertical-align-middle">
                            {{item.value}}
                        </td>
                        <td>
                            <div class="activeDesablebtn alignitemss">
                                <div class="toggle-button-cover">
                                    <div class="button-cover">
                                        <div class="button b2" id="button-14">
                                            <input type="checkbox" class="checkbox" [checked]="item.isActive"
                                            (change)="enableOrDisableItem($event, item)">
                                            <div class="knobs">
                                                <span></span>
                                            </div>
                                            <div class="layer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="vertical-align-middle text-center">
                            <img src="assets/images/pencilIocn.svg" title="Edit" alt="" style="cursor: pointer;" (click)="onEdit(item)">
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="card" *ngIf="filteredMasterDataValues.length === 0 ">
                <div class="card-body py-2 px-3">
                    <div class="emtyCard p-0">
                        <p class="mb-0">No Records Found
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>